export default {
  setIsMobile: ({ commit }, payload) => {
    commit('SET_IS_MOBILE', payload)
  },
  setAdhdFocus: ({ commit }, payload) => {
    commit('SET_ADHD_FOCUS', payload)
  },
  setIsExtraSmallMobile: ({ commit }, payload) => {
    commit('SET_IS_EXTRA_SMALL_MOBILE', payload)
  }
}
